import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
const getBaseUrl = () => '/livechat-unboxing';
export const getRootUrl = () => `${getBaseUrl()}`;
export const getCurrentUrl = () => {
  return window.location.href;
};
export const getChatflowsUrl = () => {
  const newUrl = new URL(window.location.href);
  newUrl.pathname = `/chatflows/${PortalIdParser.get()}/`;
  newUrl.host = newUrl.host.replace('local', 'app');
  return newUrl.href;
};
export const getMarketingPageUrl = () => {
  const isLocal = window.location.hostname.includes('local');
  if (isLocal) return getFullUrl('local');
  const isQa = enviro.isQa();
  return `https://www.${isQa ? 'wt' : ''}hubspot.com`;
};